import type { TerminalConfig } from "@jidlomat/terminal-core/config/terminalConfig";
import { Config } from "./eatSmartConfig";

/** What the packages get to know about this build and its environment (the config port of core). */
export const createTerminalConfig = (): TerminalConfig => ({
	alarms: Config.alarms,
	aws: {
		apiKey: Config.aws.apiKey,
		appsyncUrl: Config.aws.appsyncUrl,
		region: Config.aws.region,
	},
	connectionSettings: {
		connectionTimeout: Config.connectionSettings.connectionTimeout,
		initialStateQueryRefetchDebounce: Config.connectionSettings.initialStateQueryRefetchDebounce,
	},
	dishTypePlaceholderImage: Config.common.dishTypePlaceholderImage,
	build: {
		mode: import.meta.env.MODE,
		env: import.meta.env.VITE_ENV,
		appVersion: import.meta.env.APP_VERSION,
		buildNumber: import.meta.env.VITE_BUILD_NUMBER,
		refetchNextHourOverride: import.meta.env.VITE_REFETCH_NEXT_HOUR_OVERRIDE,
	},
});
